<script setup>
import { computed } from "vue";

const props = defineProps({
    specialWork: Array,
});

const parseHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    return Array.from(tempDiv.childNodes)
        .filter((node) => node.nodeType === 1)
        .map((node) => {
            const tag = node.nodeName.toLowerCase();
            const content = node.innerHTML;

            const containsUrl =
                tag === "p" &&
                /(?:https?:\/\/[^\s]+|mailto:[^\s]+)/gi.test(content);

            return {
                tag,
                content,
                containsUrl,
            };
        });
};

const processedDescriptions = computed(() =>
    props.specialWork.map((item) => ({
        parsedContent: parseHtml(item.description),
    }))
);
</script>

<template>
    <div
        v-for="(item, index) in specialWork"
        :key="item.id || index"
        class="grid justify-start gap-y-2 p-5 md:p-10 max-h-screen overflow-y-auto"
    >
        <h1 class="text-title-content leading-8">{{ item.title }}</h1>
        <p class="tag-p">{{ item.sub_title }}</p>

        <template v-for="(element, idx) in processedDescriptions[index].parsedContent" :key="idx">
            <component
                :is="element.tag"
                v-html="element.content"
                :class="{
                    'text-title-content-sub': element.tag === 'h1', // tag h1
                    'text-title-content-sub': element.tag === 'h2', // tag h2
                    'tag-p text-grayBlackColor leading-7 md:leading-[30px]': element.tag === 'p', // tag p
                    'text-primaryColor': element.tag === 'p' && element.containsUrl, // tag p have url.
                    'tag-ul list-disc pl-10 space-y-0 md:space-y-1 leading-7 md:leading-[30px]': element.tag === 'ul', // tag ul
                }"
            ></component>
        </template>
    </div>
</template>
